export const text = {
  Employees: "Medewerkers",
  Employee: "Medewerker",
  FullName: "Volledige naam",
  EmployeeNumber: "Medewerkersnummer",
  CompanyEmail: "Organisatie mail",
  Gender: "Geslacht",
  DateofBirth: "Geboortedatum",
  DateofJoining: "Datum van indiensttreding",
  AddEmployees: "Medewerker toevoegen",
  Onboarding: "Onboarding",
  Details: "Medewerkersgegevens",
  AssignedApps: "Toegewezen modules",
  MyDevelopment: "Mijn ontwikkeling ",
  Academy: "Academy",
  MyTeam: "Mijn team",
  PersonalInformation: "Persoonlijke gegevens",
  EnterFirstName: "Voornaam",
  EnterMiddleName: "Tussenvoegsel",
  EnterLastName: "Achternaam",
  EnterFullName: "Volledige naam",
  EnterEmail: "E-mailadres",
  Day: "Dag",
  Areyousureyouwanttodeletethis: "Weet u zeker dat u dit wilt verwijderen ?",
  Goals: "Doelen",
  GoalAttachments: "Doel bijlagen",
  MydevelopmentForms: "Mijn ontwikkeling formulieren",
  Goal: "Doel",
  StartDate: "Startdatum",
  EndDate: "Einddatum",
  Attachment: "Bijlage",
  FileName: "Bestandsnaam",
  UploadDate: "Uploaddatum",
  Form: "Formulier",
  Course: "Cursus",
  Address: "Adres",
  DisableEmployee: "Medewerker deactiveren",
  chooseProfile: "Profiel kiezen",
  CompanyInformation: "Organisatie gegevens",
  Team: "Team",
  CompanyEmail: "Organisatie mail",
  Designation: "Functietitel",
  ReportingManager: "Leidinggevende",
  IsHR: "Is HR?",
  ModuleName: "Modulenaam",
  AssignedModule: "Toegewezen module",
  AllowNotifications: "Meldingen toestaan",
  OnboardingTemplate: "Onboardingstemplate",
  OnboardingStartdate: "Startdatum onboarding",
  OnboardingQuizReport: "Onboardingquiz rapport",
  Tasks: "Taken",
  TaskType: "Taaktype",
  Task: "Taak",
  Date: "Datum",
  Status: "Status",
  Category: "Categorie",
  TotalPoint: "Totaal aantal punten",
  AssignedTeam: "Toegewezen team",
  Employeeaddedsuccessfully: "Medewerker succesvol toegevoegd",
  Pleasecompletethe: "Vul alstublieft de",
  fields: "velden in",
  field: "veld",
  AddEmployees: "Medewerker toevoegen",
  NewEmployee: "Nieuwe medewerker",
  Male: "Man",
  Female: "Vrouw",
  Other: "Anders",
  EnterEmployeeNumber: "Medewerkersnummer",
  EnterCompanyEmail: "Organisatie mail",
  Employeeupdatedsuccessfully: "Medewerker succesvol bijgewerkt",
  EmployeeName: "Naam medewerker",
  EmployeeNumber: "Medewerkersnummer",
  Quiz: "Quiz",
  Question: "Vraag",
  Option: "Optie",
  Report: "Rapport",
  Answer: "Antwoord",
  SelectEmployeeTaskType: "Selecteer taaktype medewerker",
  TaskType: "Taaktype",
  Documentation: "Documentatie",
  Video: "Video",
  Quiz: "Quiz",
  Image: "Afbeelding",
  EnterPhoneNumber: "Telefoonnummer",
  PhoneNumber: "Telefoonnummer",
  Language: "Taal",
  Completed: "Afgerond",
  Pending: "Wachtende",
  Overdue: "Verlopen",
  Submitted: "Ingediend",
  Rejected: "Afgewezen",
  Approved: "Goedgekeurd",
  Poll: "Peiling",
  Subjective: "Open vraag",
  Objective: "Meerkeuzevraag",
  Disabled: "Deactiveren",
  Enabled: "Ingeschakeld",
  disabled: "deactiveren",
  enabled: "ingeschakeld",
};
